import { graphql } from "gatsby"
import React from "react"
import { Layout } from "@bw/layouts"
import { Seo, Section, Button } from "@bw/bits"
import loadable from "@loadable/component"
import styled from "styled-components"
import { useTranslation } from "react-i18next"

const PdfViewer = loadable(
  () => import("../components/partials/pdfViewer/PdfViewer")
)

const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > * + * {
    margin-left: 20px;
  }
`

const MagazinePdfTemplate = ({ data, pageContext, location }) => {
  const { t } = useTranslation()
  const magazine = data.collectionMagazines
  const { subscribeToMagazine, allCollectionPages } = data
  let register = undefined
  if (subscribeToMagazine.subscribeToMagazine.length > 0) {
    register = allCollectionPages.nodes.find(
      node => node.statamicId === subscribeToMagazine.subscribeToMagazine[0]
    )
  }

  return (
    <Layout
      {...{ pageContext }}
      color={magazine.color?.value}
      fixedHeader={false}
    >
      <Seo
        url={location.href}
        title={magazine.metaTitle || magazine.title}
        description={magazine.metaDescription}
        image={magazine.image?.url}
        meta={[
          {
            name: "robots",
            content: magazine.doNotIndex
              ? "noindex, nofollow"
              : "max-image-preview:large, index, follow",
          },
        ]}
      />
      <Section>
        <Buttons>
          <Button to={magazine.pdf.url} label={t("magazine.download")} />
          {register && (
            <Button to={register.slug} label={t("magazine.button")} />
          )}
        </Buttons>
      </Section>
      <PdfViewer url={magazine.pdf.url} />
    </Layout>
  )
}

export default MagazinePdfTemplate

export const magazinePdfQuery = graphql`
  query magazinePdfQuery($id: String!) {
    collectionMagazines(id: { eq: $id }) {
      metaDescription
      image {
        url
      }
      metaTitle
      doNotIndex
      title
      slug
      color {
        value
      }
      pdf {
        url
      }
    }
    subscribeToMagazine: globals(
      handle: { eq: "pages" }
      subscribeToMagazine: { ne: null }
    ) {
      id
      subscribeToMagazine
    }
    allCollectionPages {
      nodes {
        statamicId
        title
        slug
      }
    }
  }
`
